import { Controller } from "stimulus"

export default class extends Controller {

    calculate() {
        if (this.isFormValid()) {
            var amount = Number(document.getElementById("amount").value) || 0;
            var interestRate = Number(document.getElementById("interest_rate").value) || 0;
            var noOfYears = Number(document.getElementById("term").value) || 0;
            var extraPayment = Number(document.getElementById("extra_payment").value) || 0;
            var monthlyPayment, averageInterest, totalInterest, totalBorrowing;
            var monthlyInterestRate = interestRate / (12 * 100);
            var termInMonth = noOfYears * 12;
            var format = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
            });

            monthlyPayment = (amount * Math.pow((monthlyInterestRate) + 1,
                (termInMonth)) * monthlyInterestRate) / (Math.pow(monthlyInterestRate + 1, (termInMonth)) - 1) || (amount / termInMonth);
            totalBorrowing = monthlyPayment * termInMonth;
            totalInterest = Math.abs(totalBorrowing - amount);
            averageInterest = totalInterest / termInMonth;

            if (extraPayment) {
                totalBorrowing = monthlyPayment * termInMonth;
                noOfYears = -Math.log(1 - monthlyInterestRate * amount / (monthlyPayment + extraPayment)) / (12 * Math.log(1 + monthlyInterestRate)) || noOfYears;
            }

            document.getElementById("monthly_payment").innerText = `${format.format(monthlyPayment)}`;
            document.getElementById("average_interest").innerText = `${format.format(averageInterest)}`;
            document.getElementById("total_interest").innerText = `${format.format(totalInterest)}`;
            document.getElementById("no_of_years").innerText = `${noOfYears.toFixed('2')}`;
            document.getElementById("total_borrowing").innerText = `${format.format(totalBorrowing)}`;
            document.getElementById("loan-calculation").classList.remove("hidden");
        }
    }

    isFormValid() {
        return document.getElementById("amount").checkValidity() && document.getElementById("interest_rate").checkValidity() &&
            document.getElementById("term").checkValidity() && document.getElementById("extra_payment").checkValidity();
    }

    reset() {
        document.getElementById("amount").value = null;
        document.getElementById("interest_rate").value = null;
        document.getElementById("term").value = null;
        document.getElementById("extra_payment").value = null;
        document.getElementById("monthly_payment").innerText = '';
        document.getElementById("average_interest").innerText = '';
        document.getElementById("total_interest").innerText = '';
        document.getElementById("total_borrowing").innerText = '';
        document.getElementById("total_borrowing").innerText = '';
        document.getElementById("loan-calculation").classList.add("hidden");
        document.getElementById("amount").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("amount").classList.remove("pt-4");
        document.getElementById("interest_rate").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("interest_rate").classList.remove("pt-4");
        document.getElementById("term").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("term").classList.remove("pt-4");
        document.getElementById("extra_payment").previousSibling.previousSibling.classList.add("opacity-0");
        document.getElementById("extra_payment").classList.remove("pt-4");
    }

    toggleLabel(event) {
        if (event.target.value.length == 0) {
            event.target.previousSibling.previousSibling.classList.add("opacity-0");
            event.target.classList.remove("pt-4");
        } else {
            event.target.previousSibling.previousSibling.classList.remove("opacity-0");
            event.target.classList.add("pt-4");
        }
    }

    copy() {
        var copyElement = document.getElementById("copy-content")
        copyElement.focus()
        this.selectText(copyElement)
        document.execCommand("copy");
        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        } else if (document.selection) {
            document.selection.empty();
        }
    }

    selectText(node) {
        if (document.body.createTextRange) {
            const range = document.body.createTextRange();
            range.moveToElementText(node);
            range.select();
        } else if (window.getSelection) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(node);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}